import styled from "styled-components";

const Content = styled.div`
  flex: 1;
  background-color: #f8f9fe;
`;

export default Content;
